'use strict';

module.exports = function whereInstanceOf(type) {
  return this.filter(function (item) {
    return item instanceof type;
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/whereInstanceOf.js
// module id = 1744
// module chunks = 2